export { default as VideoSwiper } from './VideoSwiper';
